import { addVisible, removeVisible } from './helper';
const CLS = '.validate--tooltip-notequals';

export function validateNotEquals(input1: HTMLInputElement, input2: HTMLInputElement): boolean {
    const invalid = input1.value === input2.value && input1.value !== '';
    if (invalid) {
        addVisible(input1, CLS);
        return false;
    } else {
        removeVisible(input1, CLS);
        return true;
    }
}

export function liveValidateNotEquals(input1: HTMLInputElement, input2: HTMLInputElement) {
    function validate(e: InputEvent) {
        validateNotEquals(input1, input2);
    }
    input1.addEventListener('change', validate);
    input1.addEventListener('input', validate);
    input1.addEventListener('blur', validate);
    input2.addEventListener('change', validate);
    input2.addEventListener('input', validate);
    input2.addEventListener('blur', validate);
}
